<template>
  <v-card :width="width" outlined elevation="2" :min-width="minWidth">
    <v-toolbar dense color="blue" dark>
      <v-toolbar-title>
        <slot name="toolbar">{{ title }}</slot>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-row class="d-flex flex-row-reverse mt-4" v-if="collapsible">
        <v-switch dense v-model="showOptions" color="yellow"></v-switch>
      </v-row>
    </v-toolbar>
    <v-card-text v-show="showOptions" :class="spacingClass">
      <slot name="content"></slot>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "wapi-panel",
  props: {
    value: Array,
    title: {
      type: String,
      default: ""
    },
    width: Number,
    collapsible: {
      type: Boolean,
      default: false
    },
    minWidth: Number,
    spacing: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showOptions: true
    };
  },
  computed: {
    spacingClass() {
      return this.spacing ? "" : "pa-0 ma-0";
    }
  }
};
</script>